import { toastr as orig } from "react-redux-toastr";

const DEF_OPT_1 = {
    timeOut: 15000
}
const DEF_OPT_2 = {
    timeOut: 30000
}

export const toastr = {
    info: (msg, options = DEF_OPT_1) => {
        orig.info(msg, options);
    },
    success: (msg, options = DEF_OPT_1) => {
        orig.success(msg, options);
    },
    warning: (msg, options = DEF_OPT_2) => {
        orig.warning(msg, options);
    },
    error: (msg, options = DEF_OPT_2) => {
        orig.error(msg, options);
    },
};
